import { createContext } from "react";
import { AppState, ChatState } from "../Enums";


export const ConfigContext = createContext<any | null>(null);
export const AppContext = createContext<AppState | null>(null);
export const ChatContext = createContext<ChatState | null>(null);
